import {sendGetRequest, sendPutRequest, sendPostRequest} from '../../requests';

const baseUrl = '/settings';
const processTypesUrl = 'target-time/process-types';
const fullTargetTimeUrl = (processType: string) => (
  `${baseUrl}/${processTypesUrl}/${processType}`
);

export const getTargetTimeSettings = (
    processType: string, treatmentId: string
) =>
  sendGetRequest(
      `${fullTargetTimeUrl(processType)}?treatment=${treatmentId}`
  );

export const getDefaultSettings = (keys: string) => (
  sendGetRequest(`${baseUrl}/?keys=${keys}`)
);

export const updateTargetTimeSettings = (
    processType: string,
    taskCode: string,
    treatmentId: string,
    time: number
) => (
  sendPutRequest(
      fullTargetTimeUrl(processType) +
      `/task-types/${taskCode}?treatment=${treatmentId}&time=${time}`
  )
);

export const updateProcessTimeSettings = (
    processType: string,
    treatmentId: string,
    time: number
) => (
  sendPutRequest(
      `${fullTargetTimeUrl(processType)}?treatment=${treatmentId}&time=${time}`
  )
);

export const saveDraftTargetTimeSettings = (
    processType: string,
    treatmentId: string
) => (
  sendPostRequest(
      `${fullTargetTimeUrl(processType)}?treatment=${treatmentId}`
  )
);

export const revertDraftTargetTimeSettings = (
    processType: string,
    treatmentId: string
) => (
  sendPutRequest(
      `${fullTargetTimeUrl(processType)}/revert?treatment=${treatmentId}`
  )
);
